<template>
    <div class="appointment-card">
        <div class="appointment-card-body clear">
            <div>课程名称：《{{item.title}}》</div>
            <div>上课地点：{{item.address}}</div>
            <div>上课时间：{{ starttime }}~{{ endtime }}</div>
            <div>课时长度：{{ timelength }}小时 <span class="fs2 c9">(请按时上课，记得签到哦~)</span> </div>            
        </div> 
    </div>
    <!-- appointment-card -->
</template>
<script>
import moment from 'moment'
moment.locale('zh-cn');

export default {
    name: 'ClassCard',
    props:{
        item:{  //课程信息
            type: Object,
            required: true
        },
    },
    data(){
        return {
            starttime: moment(this.item.startTime*1000).format('YYYY-MM-DD HH:mm'),
            endtime:moment(this.item.endTime*1000).format('HH:mm'),
            timelength:moment(this.item.endTime*1000).format('HH')-moment(this.item.startTime*1000).format('HH')
        }
    }
}
</script>
<style lang="less" scoped>
@mg-default:.13rem;
.appointment-card{ 
    position: relative;
    min-height: 1.2rem;
    height: auto;
    margin-top: .15rem;
    padding:.1rem; 
    font-size: .16rem; 
    background-color: #fff; 
    border-radius: .03rem; 
    box-shadow: rgba(0,0,0,.2) 0 0 .05rem; 
    color: #444;
    z-index: 1;
    overflow: hidden;
    &-body{
        // position: absolute;
        top: @mg-default; left: @mg-default; right: @mg-default;
        line-height: 1.6;
        z-index: 1;
    }
    &-footer{
        position: absolute;
        bottom: @mg-default; left: @mg-default; right: @mg-default;
        margin-top: .1rem;
        &__status{
            &--success{ 
                color: #68c864;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ClassCard.vue